import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Banner {
  name: string;
  api_token: string;
}

export interface BannerInfo {
  errors: unknown;
  listBanner: Banner;
  isAuthenticated: boolean;
}

@Module
export default class BannerModule extends VuexModule implements BannerInfo {
  errors = {};
  listBanner = {} as Banner;
  bannerDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListBanner() {
    return this.listBanner;
  }

  get getBannerDetail() {
    return this.bannerDetail;
  }

  @Mutation
  [Mutations.BANNER_LIST_DATA](listBanner) {
    this.listBanner = listBanner;
  }

  @Mutation
  [Mutations.BANNER_DETAIL_DATA](bannerDetail) {
    this.bannerDetail = bannerDetail;
  }

  @Action
  [Actions.BANNER_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/banners", payload)
        .then((data) => {
          this.context.commit(Mutations.BANNER_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.BANNER_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/banners/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.BANNER_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.BANNER_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`banners/${payload.id}/delete`, payload)
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.BANNER_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(`/banners/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
